import { IDatiqSelect } from '@dat/datiq-components-pkg/select';
import { IDatiqTimelineInput } from '@dat/datiq-components-pkg/timeline';
import { IDatiqInput } from '@dat/datiq-components-pkg/utils';
import {
    Control,
    LegacyTypes
} from '../../../models';
import Select from './select';
import Tab from './tabs';

const InputMapperMap: Record<LegacyTypes, (control: Control) => IDatiqInput> = {
    Select: (control: Control): IDatiqSelect => Select.map(control),
    Checkbox: undefined,
    Tabs: (control: Control): IDatiqTimelineInput => Tab.map(control),
};

const mapper = (controls: Control[]): IDatiqInput[] => {
    return controls
        .filter((control: Control): boolean => {
            return !!InputMapperMap[control.type];
        })
        .map((control: Control): IDatiqInput => {
            return InputMapperMap[control.type](control);
        });
};

export const SelectMapper = Select;
export const TabsMapper = Tab;

export default mapper;
